import { Icon, View } from "@aws-amplify/ui-react";
export default function ImageIcon() {
  return (
    <>
      <Icon
        width="46.41px"
        height="39.34px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 46.411521911621094,
          height: 39.3427734375,
        }}
        paths={[
          {
            d: "M0 0L46.4115 0L46.4115 39.3428L0 39.3428L0 0Z",
            fill: "rgba(225,240,255,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="23.42%"
        bottom="26.14%"
        left="20.75%"
        right="19.75%"
      ></Icon>
      <Icon
        width="39.04px"
        height="21.39px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 39.0380859375,
          height: 21.38906478881836,
        }}
        paths={[
          {
            d: "M1.27207 21.1453L0 19.8885L18.9668 0L39.0381 20.0941L37.8117 21.3891L19.0125 2.54414L1.27207 21.1453Z",
            fill: "rgba(109,158,232,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="47.7%"
        bottom="24.88%"
        left="20.78%"
        right="29.17%"
      ></Icon>
      <Icon
        width="19.98px"
        height="13.56px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 19.979881286621094,
          height: 13.55859375,
        }}
        paths={[
          {
            d: "M18.8449 13.5586L5.88047 2.45274C4.35703 4.01426 1.43203 7.01543 1.11972 7.26679L0.00761533 5.85761L0 5.86523C0.304688 5.59863 3.34394 2.49082 5.1873 0.59414L5.76621 0L19.9799 12.1799L18.8449 13.5586Z",
            fill: "rgba(109,158,232,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="50.8%"
        bottom="31.82%"
        left="54.63%"
        right="19.76%"
      ></Icon>
      <Icon
        width="7.53px"
        height="7.65px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 7.52578067779541,
          height: 7.647657871246338,
        }}
        paths={[
          {
            d: "M0 3.82383C0 4.83797 0.396442 5.81058 1.10212 6.52768C1.8078 7.24479 2.76491 7.64766 3.76289 7.64766C4.76087 7.64766 5.71798 7.24479 6.42365 6.52768C7.12933 5.81058 7.52578 4.83797 7.52578 3.82383C7.52578 2.80969 7.12933 1.83708 6.42365 1.11997C5.71798 0.402867 4.76087 0 3.76289 0C2.76491 0 1.8078 0.402867 1.10212 1.11997C0.396442 1.83708 0 2.80969 0 3.82383Z",
            fill: "rgba(109,158,232,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="31.67%"
        bottom="58.53%"
        left="59.61%"
        right="30.74%"
      ></Icon>
      <Icon
        width="47.92px"
        height="41.4px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 47.91972351074219,
          height: 41.3994140625,
        }}
        paths={[
          {
            d: "M46.2211 0L47.9197 0L47.9197 41.3994L46.2211 41.3994L46.2211 0ZM0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
            fill: "rgba(68,110,177,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="22.31%"
        bottom="24.61%"
        left="19.74%"
        right="18.83%"
      ></Icon>
      <Icon
        width="1.7px"
        height="41.4px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 1.6986329555511475,
          height: 41.3994140625,
        }}
        paths={[
          {
            d: "M0 0L1.69863 0L1.69863 41.3994L0 41.3994L0 0Z",
            fill: "rgba(68,110,177,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="22.31%"
        bottom="24.61%"
        left="19.42%"
        right="78.4%"
      ></Icon>
      <Icon
        width="46.22px"
        height="1.72px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 46.22109603881836,
          height: 1.721482515335083,
        }}
        paths={[
          {
            d: "M0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
            fill: "rgba(68,110,177,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="73.18%"
        bottom="24.61%"
        left="19.74%"
        right="21.01%"
      ></Icon>
    </>
  );
}
